<app-feedback-with-go-home
  iconType="warning"
  title="403 Not authorized"
  [textLines]="[
    'You don’t have permission to view this page.',
    'Please check your access rights or contact support if you believe this is
    an error.'
  ]"
></app-feedback-with-go-home>
